/**
 * Constants for Data Pull polling frequency configuration
 */

/** Maximum polling frequency in seconds (1 day) */
export const MAX_POLLING_FREQUENCY_SECONDS = 86400;

/** Minimum polling frequency in seconds */
export const MIN_POLLING_FREQUENCY_SECONDS = 5;
